import React from 'react';
import { Row, Col, Heading } from 'seduo-ui';
export default class Example extends React.Component {
    render() {
        return (<div>
                <Row>
                    <Col>
                        <Heading level={1}>H1</Heading>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Heading level={2}>H2</Heading>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Heading level={3}>H3</Heading>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Heading level={4}>H4</Heading>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Heading level={5}>H5</Heading>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Heading level={6}>H6</Heading>
                    </Col>
                </Row>
            </div>);
    }
}
